import { Typography, styled } from "@mui/material";

export const StyledTypography = styled(Typography)({
    mr: 2,
    ml: 2,
    variant: "body2",
    whiteSpace: "pre-wrap",
    component: "div",
    color: "primary.text",
    fontFamily: 'monospace !important',
    fontSize: '15px !important',
    fontStyle: 'normal !important',
    lineHeight: '20px !important',
    letterSpacing: '0em !important',
    overflowWrap: 'anywhere'
}) as typeof Typography;